import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bb6fdf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accounts-list" }
const _hoisted_2 = { class: "accounts-list__header" }
const _hoisted_3 = { class: "accounts-list__header--main" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "accounts-list__header--main--title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "accounts-list__header--sub" }, [
  /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('你可以选择以下账号访问'))
], -1))
const _hoisted_9 = { class: "accounts-list__content-wrap" }
const _hoisted_10 = { class: "accounts-list__content" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "item-avatar" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "item-userInfo" }
const _hoisted_15 = { class: "item-userInfo__name" }
const _hoisted_16 = { class: "item-userInfo__name--user" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "item-userInfo__tips" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "item-suffix" }
const _hoisted_22 = {
  key: 0,
  class: "item-suffix__RecommendedUse"
}
const _hoisted_23 = {
  key: 1,
  class: "item-suffix__currentAccount"
}

import { NAvatar, NScrollbar, useMessage } from 'naive-ui'
import accountsList from '../promptImages/accountsList.svg'
import companyIdentity from '../promptImages/companyIdentity.svg'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'
import { AccountList } from '@teams/common/api/account/types'
import { useUserStore } from '@teams/common/store/user'

export default /*#__PURE__*/_defineComponent({
  __name: 'multiAccountList',
  setup(__props) {

const { isPublicGroup, identitiesList } = useAccountChange()
const { switchAccount } = useUserStore()
const message = useMessage()
const identitiesListValue = identitiesList.value as AccountList[]
const onRecommendedUse = async (userId: number) => {
  await switchAccount({ userid: userId })
  window.location.reload()
}
const onCurrentAccountTips = async (userId: number) => {
  if (isPublicGroup.value) {
    await onRecommendedUse(userId)
  } else {
    message.error('当前账号不是空间成员，不可访问该空间')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(accountsList),
          class: "accounts-list__header--main--img",
          alt: "accountsList"
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          (_unref(isPublicGroup))
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString('「空间成员」可访问全部内容')))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString('该空间受到权限保护')))
        ])
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_unref(NScrollbar), {
        style: {"max-height":"260px"},
        class: "accounts-list--scrollbar"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(identitiesListValue), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "accounts-list-item-wrap",
                key: item.user_id,
                onClick: ($event: any) => (
              item?.is_member
                ? onRecommendedUse(item.user_id)
                : onCurrentAccountTips(item.user_id)
            )
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(NAvatar), {
                    round: "",
                    size: 40,
                    src: item.user_avatar
                  }, null, 8, ["src"]),
                  (item.is_company_account)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "item-avatar--mark",
                        src: _unref(companyIdentity),
                        alt: "company-mark"
                      }, null, 8, _hoisted_13))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(item.user_name), 1),
                    _createElementVNode("span", {
                      title: item.company_name
                    }, _toDisplayString(`(${item.company_name})`), 9, _hoisted_17)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    (item.is_member)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(isPublicGroup)
                      ? '空间成员，可访问全部内容'
                      : '空间成员，可直接访问'), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(isPublicGroup) ? '访客，仅可访问部分内容' : '访客，不可访问'), 1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  (index === 0 && item.is_member)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString('推荐使用')))
                    : _createCommentVNode("", true),
                  (
                  index === _unref(identitiesListValue).length - 1 && !item.is_member
                )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString('当前账号')))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_11))
            }), 128))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})